import { CircularProgress, IconButton } from "@mui/material";
import { Autocomplete, Button } from "@mui/material";
import { Box, MenuItem, useMediaQuery } from "@mui/material";
import { Modal, TextField, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { APP_BACKGROUND_COLOR } from "../../theme";
import { TEXT_COLOR } from "../../theme";
import CloseIcon from "@mui/icons-material/Close";
import { SplitSheetModalStyle } from "./styles";
import { splitSheetStyles } from "./styles";
import { SplitSheetProps } from "./types";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { updateSplitSheetDetails } from "../../services/splitSheetService";
import { RpcError } from "grpc-web";
import { GetEnterpriseAllUsersResponse } from "../../proto/api_pb";
import { Affiliation, Role, SplitSheetDetails, User } from "../../proto/api_pb";
import { Track, UpdateSplitSheetDetailsResponse } from "../../proto/api_pb";
import { SplitSheetContributorInfo } from "../../proto/api_pb";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { UserDetailsContextInterface } from "../../contexts";
import { UserDetailsContext } from "../../contexts";
import { filterMenuStyles } from "../TracksPageComponents/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import { CustomSelectField } from "../../pages/ProfilePage/styles";
import { getEnterpriseAllUsers } from "../../services/enterpriseService";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import ArticleIcon from "@mui/icons-material/Article";
import CustomButton from "../CustomButton/CustomButton";
import PrettoSliderComponent from "../Slider/PrettoSlider";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const SplitSheet: React.FC<SplitSheetProps> = ({
  handleTrackMenuClose,
  track,
  isPublishingSplitSheetDetails,
}) => {
  const [loading, setLoading] = useState(false);
  const [contributorInfo, setContributorInfo] = useState<string>("");
  const [role, setRole] = useState<string>("");
  const [affiliation, setAffiliation] = useState<string>("");
  const [publisher, setPublisher] = useState<string>("");
  const [masteringPercentage, setMasteringPercentage] = useState<number>(0);
  const [publishingPercentage, setPublishingPercentage] = useState<number>(0);
  const [contributorToEdit, setContributorToEdit] =
    useState<SplitSheetContributorInfo>();
  const [isContributorToEdit, setIsContributorToEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [remainingOwnership, setRemainingOwnership] = useState<number>(0);
  const [remainingMasteringPercentage, setRemainingMasteringPercentage] =
    useState<number>(0);
  const [description, setDescription] = useState<string>("");
  const [aka, setAka] = useState<string>("");
  const [affiliationId, setAffiliationId] = useState<string>("");
  const [songTitle, setSongTitle] = useState<string | undefined>(
    track.track?.getTitle()
  );
  const [songArtist, setSongArtist] = useState("");
  const [newDate, setNewDate] = useState<string>("");
  const [isSplitSheetEditOn, setIsSplitSheetEditOn] = useState(false);
  const { enterprise, isEnterpriseAccount } = useContext(UserDetailsContext);
  const [splitSheetDetails, setSplitSheetDetails] = useState<
    SplitSheetDetails | undefined
  >(
    isPublishingSplitSheetDetails
      ? track.track?.getPublishingSplitSheetDetails()
      : track.track?.getSplitSheetDetails()
  );
  const { userName } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);
  const [value, setValue] = useState(0);
  const [contributorInfoError, setContributorInfoError] =
    useState<boolean>(false);
  const [roleError, setRoleError] = useState<boolean>(false);
  const [affiliationError, setAffiliationError] = useState<boolean>(false);
  const [publisherError, setPublisherError] = useState<boolean>(false);
  const [publishingPercentageError, setPublishingPercentageError] =
    useState<boolean>(false);
  const [publishingPercentageExceedError, setPublishingPercentageExceedError] =
    useState<boolean>(false);
  const [masteringPercentageExceedError, setMasteringPercentageExceedError] =
    useState<boolean>(false);
  const [affiliationIdError, setAffiliationIdError] = useState<boolean>(false);
  const [userNames, setUserNames] = useState<string[]>([]);
  const [enterpriseUsers, setEnterpriseUsers] = useState<User[]>([]);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const { getValidAccessToken } = useGetValidAccessToken();
  const isSmallScreen = useMediaQuery("(max-width:700px)");
  const calculateTotalOwnership = (splitSheetDetails: SplitSheetDetails) => {
    if (!splitSheetDetails) {
      console.error("splitSheetDetails is undefined");
      return 100;
    }
    const contributorInfoList = splitSheetDetails.getContributorInfoList();
    if (!Array.isArray(contributorInfoList)) {
      console.error("contributorInfoList is undefined or not an array");
      return 100;
    }
    return contributorInfoList.reduce((total, contributor) => {
      return total + contributor.getOwnershipPercentage();
    }, 0);
  };

  const calculateTotalMasteringPercentage = (
    splitSheetDetails: SplitSheetDetails
  ) => {
    if (!splitSheetDetails) {
      console.error("splitSheetDetails is undefined");
      return 100;
    }
    const contributorInfoList = splitSheetDetails.getContributorInfoList();
    if (!Array.isArray(contributorInfoList)) {
      console.error("contributorInfoList is undefined or not an array");
      return 100;
    }
    return contributorInfoList.reduce((total, contributor) => {
      return total + contributor.getMasteringPercentage();
    }, 0);
  };

  const handleSubmitSplitSheetDetails = async () => {
    setLoading(true);
    const spp = splitSheetDetails;
    if (spp) {
      spp.setAka(aka);
      spp.setDescription(description);
      spp.setSongArtist(songArtist);
      spp.setDate(newDate);
      const token = await getValidAccessToken();
      const tr = track.track;
      if (tr) {
        tr.setTitle(songTitle!);
        if (isPublishingSplitSheetDetails) {
          tr.setPublishingSplitSheetDetails(spp);
        } else {
          tr.setSplitSheetDetails(spp);
        }
        const res = await updateSplitSheetDetails(token, tr);
        handleResponse(res, tr);
        setIsSplitSheetEditOn(false);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    if (isContributorToEdit && contributorToEdit && splitSheetDetails) {
      setContributorInfo(contributorToEdit.getContributorInfo());
      setRole(contributorToEdit.getRole());
      setPublisher(contributorToEdit.getPublisher());
      setPublishingPercentage(contributorToEdit.getOwnershipPercentage());
      setMasteringPercentage(contributorToEdit.getMasteringPercentage());
      setNewDate(splitSheetDetails.getDate());
      setDescription(splitSheetDetails.getDescription());
      setAka(splitSheetDetails.getAka());
      setSongArtist(splitSheetDetails.getSongArtist());
      // setAffiliation(contributorToEdit.getAffiliation());
      // setAffiliationId(contributorToEdit.getAffiliationId());
    } else {
      setNewDate(track.track?.getSplitSheetDetails()?.getDate() ?? "");
      setDescription(
        track.track?.getSplitSheetDetails()?.getDescription() ?? ""
      );
      setSongArtist(track.track?.getSplitSheetDetails()?.getSongArtist() ?? "");
      setAka(track.track?.getSplitSheetDetails()?.getAka() ?? "");
      // setAffiliation(contributorToEdit?.getAffiliation() ?? "");
      // setAffiliationId(contributorToEdit?.getAffiliationId() ?? "");
    }
    if (splitSheetDetails) {
      const t = calculateTotalOwnership(splitSheetDetails);
      setRemainingOwnership(100 - t);
      const m = calculateTotalMasteringPercentage(splitSheetDetails);
      setRemainingMasteringPercentage(100 - m);
    }
  }, [contributorToEdit, isContributorToEdit, splitSheetDetails, track.track]);

  const validateFields = () => {
    let isValid = true;
    if (
      contributorInfo === undefined ||
      contributorInfo === null ||
      contributorInfo === ""
    ) {
      setContributorInfoError(true);
      setLoading(false);
      toast.warning("Contributor Info cannot be empty");
      isValid = false;
    } else {
      setContributorInfoError(false);
    }
    if (role === undefined || role === null || role === "") {
      setRoleError(true);
      setLoading(false);
      toast.warning("Role cannot be empty");
      isValid = false;
    } else {
      setRoleError(false);
    }
    if (
      affiliation === undefined ||
      affiliation === null ||
      affiliation === ""
    ) {
      setAffiliationError(true);
      setLoading(false);
      toast.warning("Affiliation cannot be empty");
      isValid = false;
    } else {
      setAffiliationError(false);
    }
    if (
      affiliationId === undefined ||
      affiliationId === null ||
      affiliationId === ""
    ) {
      setAffiliationIdError(true);
      setLoading(false);
      toast.warning("Affiliation id cannot be empty");
      isValid = false;
    } else {
      setAffiliationError(false);
    }

    if (publisher === undefined || publisher === null || publisher === "") {
      setPublisherError(true);
      setLoading(false);
      toast.warning("Publisher cannot be empty");
      isValid = false;
    } else {
      setPublisherError(false);
    }

    if (
      publishingPercentage === undefined ||
      publishingPercentage === null ||
      publishingPercentage === 0
    ) {
      setPublishingPercentageError(true);
      setLoading(false);
      toast.warning("Publishing Percentage cannot be empty");
      isValid = false;
    } else {
      setPublishingPercentageError(false);
    }
    return isValid;
  };

  const createOrUpdateContributor = (
    splitSheetDetails: SplitSheetDetails | undefined
  ) => {
    if (!splitSheetDetails) {
      console.log("splitSheetDetails is undefined, creating a new instance");
      splitSheetDetails = new SplitSheetDetails();
    }
    let totalOwnership = calculateTotalOwnership(splitSheetDetails);
    let totalMasteringPercentage =
      calculateTotalMasteringPercentage(splitSheetDetails);
    if (isContributorToEdit && contributorToEdit) {
      const contributorInfoList = splitSheetDetails.getContributorInfoList();
      const contributorIndex = contributorInfoList.findIndex(
        (e) => e.getContributorInfo() === contributorToEdit.getContributorInfo()
      );
      if (contributorIndex !== -1) {
        const sp = contributorInfoList[contributorIndex];
        totalOwnership -= sp.getOwnershipPercentage();
        totalMasteringPercentage -= sp.getMasteringPercentage();
        if (totalOwnership + publishingPercentage > 100) {
          toast.error("Total ownership percentage cannot exceed 100%");
          setPublishingPercentageExceedError(true);
          setLoading(false);
          return null;
        }
        if (totalMasteringPercentage + masteringPercentage > 100) {
          toast.error("Total mastering percentage cannot exceed 100%");
          setMasteringPercentageExceedError(true);
          setLoading(false);
          return null;
        }
        sp.setContributorInfo(contributorInfo);
        sp.setRole(role);
        sp.setPublisher(publisher);
        sp.setOwnershipPercentage(publishingPercentage);
        sp.setMasteringPercentage(masteringPercentage);
        const affiliationList: Affiliation[] = [];
        const affiliation1 = new Affiliation();
        affiliation1.setName(affiliation);
        affiliation1.setId(affiliationId);
        affiliationList.push(affiliation1);
        sp.setAffiliationsList(affiliationList);
      } else {
        toast.error("Contributor to edit not found");
        return null;
      }
    } else {
      if (totalOwnership + publishingPercentage > 100) {
        toast.error("Total ownership percentage cannot exceed 100%");
        setPublishingPercentageExceedError(true);
        setLoading(false);
        return null;
      }
      if (totalMasteringPercentage + masteringPercentage > 100) {
        toast.error("Total mastering percentage cannot exceed 100%");
        setMasteringPercentageExceedError(true);
        setLoading(false);
        return null;
      }
      const sp = new SplitSheetContributorInfo();
      sp.setContributorInfo(contributorInfo);
      sp.setRole(role);
      sp.setPublisher(publisher);
      sp.setOwnershipPercentage(publishingPercentage);
      sp.setMasteringPercentage(masteringPercentage);
      const affiliationList: Affiliation[] = [];
      const affiliation1 = new Affiliation();
      affiliation1.setName(affiliation);
      affiliation1.setId(affiliationId);
      affiliationList.push(affiliation1);
      sp.setAffiliationsList(affiliationList);
      splitSheetDetails.setDate(newDate);
      splitSheetDetails.setAka(aka);
      splitSheetDetails.setDescription(description);
      splitSheetDetails.addContributorInfo(sp);
      splitSheetDetails.setSongArtist(songArtist);
    }
    splitSheetDetails.setLastModifiedBy(userName);
    return splitSheetDetails;
  };

  const handleSubmit = async () => {
    setLoading(true);
    if (!track.track) return;
    if (!validateFields()) {
      setLoading(false);
      return;
    }
    const token = await getValidAccessToken();
    const tr = track.track;
    tr.setTitle(songTitle!);
    const splitSheetDetails = isPublishingSplitSheetDetails
      ? tr.getPublishingSplitSheetDetails()
      : tr.getSplitSheetDetails();
    const updatedSplitSheetDetails = createOrUpdateContributor(
      splitSheetDetails!
    );
    if (!updatedSplitSheetDetails) return;
    if (isPublishingSplitSheetDetails) {
      tr.setPublishingSplitSheetDetails(updatedSplitSheetDetails);
    } else {
      tr.setSplitSheetDetails(updatedSplitSheetDetails);
    }
    const res = await updateSplitSheetDetails(token, tr);
    handleResponse(res, tr);
    setLoading(false);
  };
  const handleResponse = (res: any, tr: Track) => {
    if (res instanceof RpcError) {
      console.error(res);
    } else {
      toast.success("Updated successfully");
      if (value === 1) {
        setValue(0);
      }
      handleClear();
      const updatedSplitSheetDetails = isPublishingSplitSheetDetails
        ? tr.getPublishingSplitSheetDetails()
        : tr.getSplitSheetDetails();
      updatedSplitSheetDetails?.setLastModified(Math.floor(Date.now() / 1000));
      updatedSplitSheetDetails?.setLastModifiedBy(userName);
      setSplitSheetDetails(updatedSplitSheetDetails);
      if (splitSheetDetails) {
        const t = calculateTotalOwnership(splitSheetDetails);
        setRemainingOwnership(100 - t);
        const m = calculateTotalMasteringPercentage(splitSheetDetails);
        setRemainingMasteringPercentage(100 - m);
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
    handleTrackMenuClose();
  };

  const getTimestampToDate = (timeStamp: number) => {
    const date = new Date(timeStamp * 1000);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const handleDeleteContributor = async (c: SplitSheetContributorInfo) => {
    if (!splitSheetDetails) return;
    const updatedContributors = splitSheetDetails
      .getContributorInfoList()
      .filter((item) => item.getContributorInfo() !== c.getContributorInfo());

    const updatedSplitSheetDetails: SplitSheetDetails = new SplitSheetDetails();
    updatedSplitSheetDetails.setAka(splitSheetDetails.getAka());
    updatedSplitSheetDetails.setDescription(splitSheetDetails.getDescription());
    updatedSplitSheetDetails.setDate(splitSheetDetails.getDate());
    updatedSplitSheetDetails.setLastModified(
      splitSheetDetails.getLastModified()
    );
    updatedSplitSheetDetails.setLastModifiedBy(
      splitSheetDetails.getLastModifiedBy()
    );
    updatedSplitSheetDetails.setSongArtist(splitSheetDetails.getSongArtist());
    updatedSplitSheetDetails.setContributorInfoList(updatedContributors);
    updatedSplitSheetDetails?.setLastModified(Math.floor(Date.now() / 1000));
    updatedSplitSheetDetails?.setLastModifiedBy(userName);
    setSplitSheetDetails(updatedSplitSheetDetails);
    const token = await getValidAccessToken();
    const tr = track.track;
    if (tr) {
      if (isPublishingSplitSheetDetails) {
        tr.setPublishingSplitSheetDetails(updatedSplitSheetDetails);
      } else {
        tr.setSplitSheetDetails(updatedSplitSheetDetails);
      }
      const res = await updateSplitSheetDetails(token, tr);
      if (res instanceof UpdateSplitSheetDetailsResponse) {
        console.log("Updated split sheet details:", res);
        toast.info("Updated successfully");
      } else {
        console.log(res);
      }
    }
  };

  const handleClear = () => {
    setContributorInfo("");
    setRole("");
    setAffiliation("");
    setPublisher("");
    setMasteringPercentage(0);
    setPublishingPercentage(0);
    setIsContributorToEdit(false);
    setContributorToEdit(undefined);
    setAffiliationId("");
  };

  const handleAffiliationChange = (event: any) => {
    if ((event.target.value as string) === "") {
      setAffiliationError(true);
      setLoading(false);
    } else {
      setAffiliationError(false);
    }
    setAffiliation(event.target.value as string);
  };

  useEffect(() => {
    const handleUserNames = async () => {
      const token = await getValidAccessToken();
      const res = await getEnterpriseAllUsers(token, enterprise?.id ?? "");
      if (res instanceof GetEnterpriseAllUsersResponse) {
        const uName = res
          .getUsersList()
          .filter((user) => !user.getUsername()?.includes("dummy_ommuse"))
          .map((user) => user.getUsername() || user.getEmail());
        setUserNames(uName);
        setEnterpriseUsers(
          res
            .getUsersList()
            .filter((user) => !user.getUsername()?.includes("dummy_ommuse"))
        );
      }
    };
    handleUserNames();
  }, [enterprise?.id, getValidAccessToken]);

  return (
    <>
      <MenuItem onClick={() => setOpen(true)}>
        <ArticleIcon style={{ margin: "2px", marginRight: "8px" }} />
        {isPublishingSplitSheetDetails
          ? "Split Sheet - Producer"
          : "Split Sheet - Songwriter"}
      </MenuItem>
      <Modal
        onKeyDown={(e) => {
          if (
            e.key === "e" ||
            e.key === "s" ||
            e.key === "d" ||
            e.code === "KeyS" ||
            e.code === "KeyD" ||
            e.code === "KeyE" ||
            e.key === "Tab"
          ) {
            e.stopPropagation();
          }
        }}
        sx={splitSheetStyles.modal}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <SplitSheetModalStyle sx={{ width: value === 0 ? "70%" : "70%" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Box sx={splitSheetStyles.filterNoneIcon}>
                <ArticleIcon />
              </Box>
              <Typography
                variant="h5"
                style={{
                  color: TEXT_COLOR,
                  fontWeight: "bold",
                }}
              >
                {isPublishingSplitSheetDetails
                  ? "Split Sheet - Producer"
                  : "Split Sheet - Songwriter"}
              </Typography>
            </Box>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          {Number(enterprise?.role) !== Role.ROLE_ADMIN && (
            <Typography
              sx={{ color: TEXT_COLOR, marginTop: "10px", fontWeight: "bold" }}
              id="modal-modal-title"
              variant="h6"
            >
              Song Split Sheet
            </Typography>
          )}
          <Box sx={{ width: "100%", marginTop: "15px" }}>
            <Box
              sx={
                Number(enterprise?.role) === Role.ROLE_ADMIN
                  ? { borderBottom: 1, borderColor: "divider" }
                  : {}
              }
            >
              {Number(enterprise?.role) === Role.ROLE_ADMIN && (
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  TabIndicatorProps={{ style: { backgroundColor: TEXT_COLOR } }}
                  sx={{
                    "& .MuiTabs-indicator": { backgroundColor: TEXT_COLOR },
                  }}
                >
                  <Tab
                    sx={splitSheetStyles.tab}
                    label="Split Sheet Details"
                    {...a11yProps(0)}
                  />
                  <Tab
                    sx={splitSheetStyles.tab}
                    label="Add Contributor"
                    {...a11yProps(1)}
                  />
                </Tabs>
              )}
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Box sx={{ marginTop: "10px" }}>
                <Typography
                  variant="h5"
                  style={{
                    color: TEXT_COLOR,
                    fontWeight: "bold",
                    marginBottom: "15px",
                  }}
                >
                  Split Sheet Details
                  <IconButton
                    sx={{
                      margin: 0,
                      padding: 0,
                      border: `1px solid ${TEXT_COLOR}`,
                      width: "30px",
                      height: "30px",
                      borderRadius: 1,
                      marginLeft: "10px",
                    }}
                    onClick={() => setIsSplitSheetEditOn(!isSplitSheetEditOn)}
                  >
                    <EditIcon sx={{ fontSize: "22px" }} />
                  </IconButton>
                </Typography>
                <Box
                  sx={{
                    display: isSmallScreen ? "block" : "flex",
                    gap: "10px",
                  }}
                >
                  <Box>
                    <img
                      src={
                        track.track?.getImageUrl() &&
                        track.track?.getImageUrl().includes("http")
                          ? track.track?.getImageUrl()
                          : isEnterpriseAccount
                          ? enterprise?.image
                          : "/assets/images/logo512.png"
                      }
                      alt=""
                      style={splitSheetStyles.trackImage}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: isSmallScreen ? "100%" : "80%",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    <Box sx={{ width: isSmallScreen ? "100%" : "49%" }}>
                      <Typography
                        sx={{ color: TEXT_COLOR, fontWeight: "bold" }}
                      >
                        Song Artist
                      </Typography>
                      {isSplitSheetEditOn ? (
                        <TextField
                          fullWidth
                          value={songArtist}
                          onChange={(e) => setSongArtist(e.target.value)}
                          size="small"
                          placeholder="Song Artist"
                        />
                      ) : (
                        <Typography sx={{ color: TEXT_COLOR }}>
                          {track.track?.getSplitSheetDetails()?.getSongArtist()}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ width: isSmallScreen ? "100%" : "49%" }}>
                      <Typography
                        sx={{ color: TEXT_COLOR, fontWeight: "bold" }}
                      >
                        AKA(s)
                      </Typography>
                      {isSplitSheetEditOn ? (
                        <TextField
                          fullWidth
                          value={aka}
                          onChange={(e) => setAka(e.target.value)}
                          size="small"
                          placeholder="AkA(s)"
                        />
                      ) : (
                        <Typography sx={{ color: TEXT_COLOR }}>
                          {track.track?.getSplitSheetDetails()?.getAka()}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ width: isSmallScreen ? "100%" : "49%" }}>
                      <Typography
                        sx={{ color: TEXT_COLOR, fontWeight: "bold" }}
                      >
                        Song Title
                      </Typography>
                      {isSplitSheetEditOn ? (
                        <TextField
                          fullWidth
                          value={songTitle}
                          onChange={(e) => setSongTitle(e.target.value)}
                          size="small"
                          placeholder="Title"
                        />
                      ) : (
                        <Typography sx={{ color: TEXT_COLOR }}>
                          {track.track?.getTitle()}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ width: isSmallScreen ? "100%" : "49%" }}>
                      <Typography
                        sx={{ color: TEXT_COLOR, fontWeight: "bold" }}
                      >
                        Notes
                      </Typography>
                      {isSplitSheetEditOn ? (
                        <TextField
                          fullWidth
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          size="small"
                          placeholder="Description"
                        />
                      ) : (
                        <Typography sx={{ color: TEXT_COLOR }}>
                          {track.track
                            ?.getSplitSheetDetails()
                            ?.getDescription()}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ width: isSmallScreen ? "100%" : "49%" }}>
                      <Typography
                        sx={{ color: TEXT_COLOR, fontWeight: "bold" }}
                      >
                        Date
                      </Typography>
                      {isSplitSheetEditOn ? (
                        <TextField
                          type="date"
                          value={newDate}
                          fullWidth
                          onChange={(e) => setNewDate(e.target.value)}
                          size="small"
                          placeholder="Date"
                          inputProps={{
                            max: "2099-12-31",
                          }}
                        />
                      ) : (
                        <Typography sx={{ color: TEXT_COLOR }}>
                          {track.track?.getSplitSheetDetails()?.getDate()}
                        </Typography>
                      )}
                    </Box>
                    {isSplitSheetEditOn && (
                      <Box
                        sx={{
                          width: isSmallScreen ? "100%" : "49%",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Box sx={{ height: "25px" }}></Box>
                        <Box
                          sx={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <CustomButton
                            onClick={handleSubmitSplitSheetDetails}
                            text="Save"
                            loading={loading}
                            customStyles={{
                              width: isSmallScreen ? "100%" : "49%",
                              marginTop: 0,
                              height: "38px",
                            }}
                          />
                          <CustomButton
                            onClick={() => setIsSplitSheetEditOn(false)}
                            text="Cancel"
                            isSkipButton={true}
                            customStyles={{
                              width: isSmallScreen ? "100%" : "49%",
                              marginTop: 0,
                              height: "38px",
                            }}
                          />
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  ...splitSheetStyles.tableScrollContainer,
                  ...{
                    width: isSmallScreen ? "310px" : "100%",
                  },
                }}
              >
                <Box sx={splitSheetStyles.tableContainer}>
                  <Box sx={splitSheetStyles.th}>
                    <Box sx={{ width: "200px" }}>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Contributor
                      </Typography>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Name & <br /> contact info
                      </Typography>
                    </Box>
                    <Box sx={{ width: "200px" }}>
                      <Typography sx={{ color: TEXT_COLOR }}>Role</Typography>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Songwriter <br />
                        /publisher
                      </Typography>
                    </Box>
                    <Box sx={{ width: "200px" }}>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Affiliation
                      </Typography>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        ASCAP,BMI,
                        <br />
                        SESAC
                      </Typography>
                    </Box>
                    <Box sx={{ width: "200px" }}>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Affiliation ID
                      </Typography>
                    </Box>
                    <Box sx={{ width: "200px" }}>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Publisher
                      </Typography>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Name <br />& contact info
                      </Typography>
                    </Box>
                    <Box sx={{ width: "200px" }}>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Mastering
                      </Typography>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Percentage
                      </Typography>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Remaining ({remainingMasteringPercentage}%)
                      </Typography>
                    </Box>
                    <Box sx={{ width: "200px" }}>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Publishing
                      </Typography>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Percentage
                      </Typography>
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Remaining ({remainingOwnership}%)
                      </Typography>
                    </Box>
                    {Number(enterprise?.role) === Role.ROLE_ADMIN && (
                      <Box
                        sx={{
                          display: "flex",
                          position: isSmallScreen ? "sticky" : "",
                          right: 0,
                          alignItems: "center",
                          background:
                            "var(--Colors-Background-bg-secondary, #161B26)",
                          width: "100px",
                        }}
                      >
                        <Typography sx={{ color: TEXT_COLOR }}>
                          Actions
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  {splitSheetDetails
                    ?.getContributorInfoList()
                    .map((item, index) => (
                      <Box key={index} sx={splitSheetStyles.td}>
                        <Box sx={{ width: "200px" }}>
                          {contributorToEdit?.getContributorInfo() !==
                            item.getContributorInfo() && (
                            <Typography sx={{ color: TEXT_COLOR }}>
                              {item.getContributorInfo()}
                            </Typography>
                          )}
                          {contributorToEdit?.getContributorInfo() ===
                            item.getContributorInfo() && (
                            <TextField
                              error={contributorInfoError}
                              fullWidth
                              value={contributorInfo}
                              size="small"
                              onChange={(e) => {
                                setContributorInfoError(false);
                                setContributorInfo(e.target.value);
                              }}
                              placeholder=""
                            />
                          )}
                        </Box>
                        <Box sx={{ width: "200px" }}>
                          {contributorToEdit?.getContributorInfo() !==
                            item.getContributorInfo() && (
                            <Typography sx={{ color: TEXT_COLOR }}>
                              {item.getRole()}
                            </Typography>
                          )}
                          {contributorToEdit?.getContributorInfo() ===
                            item.getContributorInfo() && (
                            <TextField
                              error={roleError}
                              size="small"
                              fullWidth
                              value={role}
                              onChange={(e) => {
                                setRoleError(false);
                                setRole(e.target.value);
                              }}
                              placeholder=""
                            />
                          )}
                        </Box>
                        <Box sx={{ width: "200px" }}>
                          {contributorToEdit?.getContributorInfo() !==
                            item.getContributorInfo() && (
                            <Typography sx={{ color: TEXT_COLOR }}>
                              {item.getAffiliationsList()[0]?.getName() ?? null}
                            </Typography>
                          )}
                          {contributorToEdit?.getContributorInfo() ===
                            item.getContributorInfo() && (
                            <CustomSelectField
                              error={affiliationError}
                              value={affiliation}
                              size="small"
                              MenuProps={{
                                PaperProps: {
                                  sx: filterMenuStyles.genreMenuProps,
                                },
                              }}
                              sx={{ width: "100%" }}
                              label=""
                              displayEmpty
                              onChange={handleAffiliationChange}
                            >
                              <MenuItem value={""}>Select Affiliation</MenuItem>
                              <MenuItem value={"ASCAP"}>ASCAP</MenuItem>
                              <MenuItem value={"BMI"}>BMI</MenuItem>
                              <MenuItem value={"SESAC"}>SESAC</MenuItem>
                            </CustomSelectField>
                          )}
                        </Box>
                        <Box sx={{ width: "200px" }}>
                          {contributorToEdit?.getContributorInfo() !==
                            item.getContributorInfo() && (
                            <Typography sx={{ color: TEXT_COLOR }}>
                              {item.getAffiliationsList()[0]?.getId() ?? ""}
                            </Typography>
                          )}
                          {contributorToEdit?.getContributorInfo() ===
                            item.getContributorInfo() && (
                            <TextField
                              error={affiliationIdError}
                              fullWidth
                              value={affiliationId}
                              onChange={(e) => {
                                setAffiliationIdError(false);
                                setAffiliationId(e.target.value);
                              }}
                              size="small"
                              placeholder="Affiliation ID"
                            />
                          )}
                        </Box>
                        <Box sx={{ width: "200px" }}>
                          {contributorToEdit?.getContributorInfo() !==
                            item.getContributorInfo() && (
                            <Typography sx={{ color: TEXT_COLOR }}>
                              {item.getPublisher()}
                            </Typography>
                          )}
                          {contributorToEdit?.getContributorInfo() ===
                            item.getContributorInfo() && (
                            <TextField
                              error={publisherError}
                              size="small"
                              fullWidth
                              value={publisher}
                              onChange={(e) => {
                                setPublisherError(false);
                                setPublisher(e.target.value);
                              }}
                              placeholder=""
                            />
                          )}
                        </Box>
                        <Box sx={{ width: "200px" }}>
                          {contributorToEdit?.getContributorInfo() !==
                            item.getContributorInfo() && (
                            <Typography sx={{ color: TEXT_COLOR }}>
                              {item.getMasteringPercentage().toFixed(2)}%
                            </Typography>
                          )}
                          {contributorToEdit?.getContributorInfo() ===
                            item.getContributorInfo() && (
                            <TextField
                              error={masteringPercentageExceedError}
                              fullWidth
                              size="small"
                              value={
                                masteringPercentage === 0
                                  ? ""
                                  : masteringPercentage
                              }
                              onChange={(e) => {
                                setMasteringPercentageExceedError(false);
                                if (Number(e.target.value) >= 0) {
                                  setMasteringPercentage(
                                    Number(e.target.value)
                                  );
                                }
                              }}
                              placeholder=""
                              type="number"
                            />
                          )}
                        </Box>
                        <Box sx={{ width: "200px" }}>
                          {contributorToEdit?.getContributorInfo() !==
                            item.getContributorInfo() && (
                            <Typography sx={{ color: TEXT_COLOR }}>
                              {item.getOwnershipPercentage().toFixed(2)}%
                            </Typography>
                          )}
                          {contributorToEdit?.getContributorInfo() ===
                            item.getContributorInfo() && (
                            <TextField
                              error={publishingPercentageExceedError}
                              fullWidth
                              size="small"
                              value={
                                publishingPercentage === 0
                                  ? ""
                                  : publishingPercentage
                              }
                              onChange={(e) => {
                                setPublishingPercentageExceedError(false);
                                if (Number(e.target.value) >= 0) {
                                  setPublishingPercentage(
                                    Number(e.target.value)
                                  );
                                }
                              }}
                              type="number"
                              placeholder=""
                            />
                          )}
                        </Box>
                        {Number(enterprise?.role) === Role.ROLE_ADMIN && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              position: isSmallScreen ? "sticky" : "",
                              backgroundColor: APP_BACKGROUND_COLOR,
                              right: 0,
                            }}
                          >
                            {contributorToEdit?.getContributorInfo() !==
                              item.getContributorInfo() && (
                              <IconButton
                                onClick={() => {
                                  setContributorToEdit(item);
                                  setAffiliation(
                                    item.getAffiliationsList()[0]?.getName() ??
                                      null
                                  );
                                  setAffiliationId(
                                    item.getAffiliationsList()[0]?.getId() ?? ""
                                  );
                                  setIsContributorToEdit(true);
                                }}
                              >
                                <EditIcon
                                  sx={{ color: TEXT_COLOR }}
                                  fontSize="small"
                                />
                              </IconButton>
                            )}
                            {isConfirmationModalOpen && (
                              <DeleteConfirmationModal
                                isMessageModalOpen={true}
                                message="Are you sure you want to delete the contributor?"
                                toggle={() =>
                                  setIsConfirmationModalOpen((prev) => !prev)
                                }
                                handleConfirm={async () => {
                                  if (item) await handleDeleteContributor(item);
                                  setIsConfirmationModalOpen(false);
                                }}
                              />
                            )}
                            {contributorToEdit?.getContributorInfo() !==
                              item.getContributorInfo() && (
                              <IconButton
                                onClick={() => {
                                  setIsConfirmationModalOpen(true);
                                }}
                              >
                                <DeleteIcon
                                  sx={{ color: TEXT_COLOR }}
                                  fontSize="small"
                                />
                              </IconButton>
                            )}
                            {contributorToEdit?.getContributorInfo() ===
                              item.getContributorInfo() && (
                              <Button
                                onClick={handleSubmit}
                                sx={splitSheetStyles.saveButton}
                              >
                                {loading ? (
                                  <CircularProgress
                                    size={"15px"}
                                    sx={{ color: "black" }}
                                  />
                                ) : (
                                  "Save"
                                )}
                              </Button>
                            )}
                          </Box>
                        )}
                      </Box>
                    ))}
                  {splitSheetDetails?.getContributorInfoList().length === 0 && (
                    <Box
                      sx={{
                        height: "20vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography sx={{ color: TEXT_COLOR }}>
                        Contributors are not added!{" "}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Box sx={{ marginTop: "15px" }}>
                <Typography
                  variant="h6"
                  sx={{ color: TEXT_COLOR, fontWeight: "bold" }}
                >
                  Edit Sheet Details
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: isSmallScreen ? "wrap" : "none",
                    gap: "20px",
                    marginTop: "10px",
                  }}
                >
                  <Box sx={{ width: isSmallScreen ? "100%" : "50%" }}>
                    <Typography
                      sx={{ color: TEXT_COLOR, marginBottom: "10px" }}
                    >
                      Contributors info
                      <span className="asterisk">*</span>
                    </Typography>
                    <Autocomplete
                      disablePortal
                      fullWidth
                      freeSolo
                      options={userNames}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={contributorInfoError}
                          helperText={
                            contributorInfoError ? "Cannot be empty" : ""
                          }
                          placeholder="Contributor name and contact info"
                        />
                      )}
                      value={contributorInfo}
                      onChange={(event, newValue) => {
                        const selectedValue = newValue || "";
                        setContributorInfo(selectedValue);
                        setContributorInfoError(false);
                      }}
                      onInputChange={(event, newInputValue) => {
                        setContributorInfo(newInputValue);
                        setContributorInfoError(false);
                        if (
                          newInputValue &&
                          userNames.includes(newInputValue)
                        ) {
                          const selectedU = enterpriseUsers.find(
                            (user) => user.getUsername() === newInputValue
                          );
                          setAffiliation(
                            selectedU?.getAffiliationsList()[0]?.getName() ?? ""
                          );
                          setAffiliationId(
                            selectedU?.getAffiliationsList()[0]?.getId() || ""
                          );
                        } else {
                          setAffiliation("");
                          setAffiliationId("");
                        }
                      }}
                    />
                  </Box>
                  <Box sx={{ width: isSmallScreen ? "100%" : "50%" }}>
                    <Typography
                      sx={{ color: TEXT_COLOR, marginBottom: "10px" }}
                    >
                      Role
                      <span className="asterisk">*</span>
                    </Typography>
                    <TextField
                      helperText={roleError ? "Cannot be empty" : ""}
                      error={roleError}
                      fullWidth
                      value={role}
                      onChange={(e) => {
                        setRoleError(false);
                        setRole(e.target.value);
                      }}
                      placeholder="Songwriter/ publisher etc"
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: isSmallScreen ? "wrap" : "none",
                    gap: "20px",
                    marginTop: "10px",
                  }}
                >
                  <Box sx={{ width: isSmallScreen ? "100%" : "50%" }}>
                    <Typography
                      sx={{ color: TEXT_COLOR, marginBottom: "10px" }}
                    >
                      Affiliation
                      <span className="asterisk">*</span>
                    </Typography>
                    <CustomSelectField
                      error={affiliationError}
                      value={affiliation}
                      sx={{ width: "100%" }}
                      displayEmpty
                      MenuProps={{
                        PaperProps: {
                          sx: filterMenuStyles.genreMenuProps,
                        },
                      }}
                      fullWidth
                      onChange={handleAffiliationChange}
                    >
                      <MenuItem value="" disabled>
                        Select an Affiliation
                      </MenuItem>
                      <MenuItem value={"ASCAP"}>ASCAP</MenuItem>
                      <MenuItem value={"BMI"}>BMI</MenuItem>
                      <MenuItem value={"SESAC"}>SESAC</MenuItem>
                    </CustomSelectField>
                  </Box>
                  <Box sx={{ width: isSmallScreen ? "100%" : "50%" }}>
                    <Typography
                      sx={{ color: TEXT_COLOR, marginBottom: "10px" }}
                    >
                      Publisher
                      <span className="asterisk">*</span>
                    </Typography>
                    <TextField
                      helperText={publisherError ? "Cannot be empty" : ""}
                      error={publisherError}
                      fullWidth
                      value={publisher}
                      onChange={(e) => {
                        setPublisherError(false);
                        setPublisher(e.target.value);
                      }}
                      placeholder="Publisher name and contact info"
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: isSmallScreen ? "wrap" : "none",
                    gap: "30px",
                    marginTop: "10px",
                  }}
                >
                  <Box
                    sx={{
                      width: isSmallScreen ? "100%" : "50%",
                      paddingTop: "5px",
                    }}
                  >
                    <Typography
                      sx={{ color: TEXT_COLOR, marginBottom: "10px" }}
                    >
                      Mastering (remaining{" "}
                      {isContributorToEdit && contributorToEdit
                        ? contributorToEdit?.getMasteringPercentage() +
                          remainingMasteringPercentage.toFixed(2)
                        : remainingMasteringPercentage.toFixed(2)}
                      %)
                    </Typography>
                    <PrettoSliderComponent
                      value={masteringPercentage}
                      valueLabelDisplay="on"
                      // ariaLabel="Mastering Percentage"
                      min={0}
                      max={remainingMasteringPercentage}
                      onChange={(_, newValue) => {
                        if (Array.isArray(newValue)) return; // Ignore arrays
                        setMasteringPercentageExceedError(false);
                        if (newValue >= 0 && newValue <= 100) {
                          setMasteringPercentage(newValue);
                        } else {
                          setMasteringPercentageExceedError(true);
                        }
                      }}
                    />
                    {masteringPercentageExceedError && (
                      <Typography color="error" variant="body2">
                        Percentage cannot exceed 100%
                      </Typography>
                    )}
                    <Typography variant="body2">
                      Selected:{" "}
                      {masteringPercentage === 0 ? "" : masteringPercentage}%
                    </Typography>
                  </Box>
                  <Box sx={{ width: isSmallScreen ? "100%" : "50%" }}>
                    <Typography
                      sx={{ color: TEXT_COLOR, marginBottom: "10px" }}
                    >
                      Publishing Percentage <span className="asterisk">*</span>{" "}
                      (remaining{" "}
                      {isContributorToEdit && contributorToEdit
                        ? contributorToEdit?.getOwnershipPercentage() +
                          remainingOwnership.toFixed(2)
                        : remainingOwnership.toFixed(2)}
                      %)
                    </Typography>
                    <PrettoSliderComponent
                      value={publishingPercentage}
                      valueLabelDisplay="on"
                      // ariaLabel="Publishing Percentage"
                      min={0}
                      max={remainingOwnership}
                      onChange={(_, newValue) => {
                        if (Array.isArray(newValue)) return; // Ignore arrays for single-value sliders
                        setPublishingPercentageExceedError(false);
                        setPublishingPercentageError(false);
                        if (newValue >= 0 && newValue <= 100) {
                          setPublishingPercentage(newValue);
                        } else {
                          setPublishingPercentageExceedError(true);
                        }
                      }}
                    />
                    {(publishingPercentageExceedError ||
                      publishingPercentageError) && (
                      <Typography color="error" variant="body2">
                        {publishingPercentageExceedError
                          ? "Percentage cannot exceed 100%"
                          : "Cannot be empty"}
                      </Typography>
                    )}
                    <Typography variant="body2">
                      Selected:{" "}
                      {publishingPercentage === 0 ? "" : publishingPercentage}%
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: isSmallScreen ? "100%" : "50%",
                    marginTop: "10px",
                    paddingRight: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      color: TEXT_COLOR,
                      marginBottom: "10px",
                    }}
                  >
                    Affiliation ID
                    <span className="asterisk">*</span>
                  </Typography>
                  <TextField
                    helperText={affiliationIdError ? "Cannot be empty" : ""}
                    error={affiliationIdError}
                    fullWidth
                    value={affiliationId}
                    onChange={(e) => {
                      setAffiliationIdError(false);
                      setAffiliationId(e.target.value);
                    }}
                    placeholder="Affiliation ID"
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: "15px",
                    marginTop: "20px",
                    justifyContent: isSmallScreen ? "center" : "flex-end",
                    alignItems: "center",
                    flexDirection: isSmallScreen ? "column" : "row",
                    marginLeft: isSmallScreen ? "10px" : "0px",
                  }}
                >
                  <CustomButton
                    onClick={async () => {
                      await handleSubmit();
                    }}
                    loading={loading}
                    text="Submit"
                    customStyles={{ width: isSmallScreen ? "100%" : "48%" }}
                  />

                  <CustomButton
                    onClick={() => {
                      handleClear();
                      setValue(0);
                    }}
                    text="Cancel"
                    customStyles={{ width: isSmallScreen ? "100%" : "48%" }}
                    isSkipButton={true}
                  />
                </Box>
              </Box>
            </CustomTabPanel>
          </Box>
          <Box
            sx={{
              display: isSmallScreen ? "block" : "flex",
              padding: "0px 20px 0px 20px",
              gap: isSmallScreen ? "15px" : 0,
            }}
          >
            <Box sx={{ width: isSmallScreen ? "100%" : "50%" }}>
              <Typography sx={{ color: TEXT_COLOR, fontSize: "14px" }}>
                NOTE: This is not a legal binding contract but will be utilised
                as a pre-publishing template.
              </Typography>
            </Box>
            <Box
              sx={{
                width: isSmallScreen ? "100%" : "50%",
                display: "flex",
                justifyContent: isSmallScreen ? "flex-start" : "flex-end",
              }}
            >
              {splitSheetDetails?.getLastModifiedBy() !== "" && (
                <Typography sx={{ color: TEXT_COLOR, fontSize: "14px" }}>
                  Last updated:{" "}
                  {getTimestampToDate(
                    splitSheetDetails?.getLastModified() ?? 0
                  )}{" "}
                  by {splitSheetDetails?.getLastModifiedBy()}
                </Typography>
              )}
            </Box>
          </Box>
        </SplitSheetModalStyle>
      </Modal>
    </>
  );
};
